import {
  DataActionTypes,
  productsPageActionTypes,
} from "../actions/actiontypes";

export const setproductsData = (value) => {
  return {
    type: DataActionTypes.set_ProductsData,
    payload: value,
  };
};

export const setSelectedProducts = (value) => {
  return {
    type: productsPageActionTypes.set_Selected_Products,
    payload: value,
  };
};

export const deleteSelectedProduct = (value) => {
  return {
    type: productsPageActionTypes.delete_Selected_Products,
    payload: value,
  };
};

export const deleteProductCategory = (value) => {
  return {
    type:productsPageActionTypes.delete_Product_category,
    payload:value
  };
};

export const showAddProductDivAction=(value)=>{
  return{
    type:productsPageActionTypes.on_Add_Product,
    payload:value
  }
}

export const addNewProductAction=(value)=>{
  return{
    type:productsPageActionTypes.Add_Product,
    payload:value
  }
}

export const showProductDetialsAction=(value)=>{
  return{
    type:productsPageActionTypes.on_Show_Product,
    payload:value
  }
}
export const showAddCategoryAction=(value)=>{
  return{
    type:productsPageActionTypes.show_Add_Category,
    payload:value,
  }
}

export const AddNewCategoryAction=(value)=>{
  return{
    type:productsPageActionTypes.on_Add_Category,
    payload:value
  }
}